import gql from "graphql-tag";
const getFitsQuery = gql(` 
query GetFits($params: AWSJSON!) {
  getFits(params: $params) {
  nearest
  }
}
`)
export default getFitsQuery;
